// removed by extract-text-webpack-plugin
module.exports = {"floatButton":"QuestionGroupEditor-floatButton-223bW"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/QuestionGroupEditor.styl
// module id = ./modules/issFrontend/styles/QuestionGroupEditor.styl
// module chunks = 1